// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "-" + {"118":"856859f0","340":"9c231e1e"}[chunkId] + ".css";
};